import { IStrategyPermissions } from './IStrategyPermissions';

export class StrategyPermissions implements IStrategyPermissions {
  static readonly CAN_ADD_STRATEGY = 'can_add_strategy';
  static readonly CAN_VIEW_STRATEGY = 'can_view_strategy';
  static readonly CAN_EDIT_STRATEGY_BODY = 'can_edit_strategy_body';
  static readonly CAN_EDIT_STRATEGY_NAME_DATES = 'can_edit_strategy_name_dates';
  static readonly CAN_DOWNLOAD_STRATEGY = 'can_download_strategy';
  static readonly CAN_DELETE_STRATEGY = 'can_delete_strategy';
  static readonly CAN_COPY_STRATEGY = 'can_copy_strategy';
  static readonly CAN_MANAGE_USERS = 'can_manage_users';

  canView = false;
  canAdd = false;
  canEditBody = false;
  canEditNameDates = false;
  canDelete = false;
  canDownload = false;
  canCopy = false;
  canManageUsers = false;
}
